<template>
    <div class="container-fluid pb-5">

        <div class="row py-3">
            <div class="col-md-12"><h1 class="text-center">Currency list</h1></div>
        </div>

        <div class="d-flex justify-content-center mt-5">
            <div class="col-md-10">
                <div class="alert alert-success text-center" v-if="successMsg">
                    {{ successMsg }}
                </div>
                <div class="pb-3">
                    <b-button @click="showModal = true" variant="success">Add new</b-button>
                </div>
                <currencies-table :currencies="currencies" @onMessage="onMessage"></currencies-table>

                <b-pagination v-if="total > itemsPerPage" size="md" :total-rows="total" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>
            </div>
        </div>

        <b-modal
                v-model="showModal"
                title="Add a new currency"
                header-bg-variant=""
                header-text-variant="dark">
            <div slot="modal-header-close"></div>
            <p>Search by '[symbol]' or by 'Name'</p>
            <form v-on:submit.prevent="onSubmit">
                <multiselect
                        id="currency"
                        v-model="currency"
                        :options="currencyarray"
                        label="symbol"
                        track-by="id"
                        @input="onSelectCurrency(currency)"
                        :optionsLimit=this.optionsLimit
                        select-label=""
                        :disabled="false"
                        :custom-label="customLabel"
                ></multiselect>
            </form>
            <div slot="modal-footer" class="w-100">
                <b-btn size="sm" class="float-right" variant="primary" @click="onSubmit">Save</b-btn>
            </div>
        </b-modal>
    </div>
</template>


<script>
  import axios from 'axios'
  import CurrenciesTable from '../components/tables/CurrenciesTable'
  import Multiselect from 'vue-multiselect'

  const API_V1_URL = process.env.API_V1_URL

  export default {
    components: {
      CurrenciesTable,
      Multiselect,
    },
    data() {
      return {
        showModal: false,
        optionsLimit: 200,
        currency: null,
        currencyarray: [],
        currenciesAvailable: [],
        baseAsset: null,
        currentPage: 1,
        itemsPerPage: 200,
        successMsg: null,
      }
    },
    created() {
      fetch('https://api.coingecko.com/api/v3/coins/list', {headers: {'Accept': '*/*'}})
        .then(resp => resp.json())
        .then(data => {
          this.currencyarray.push(...data)
        })
      const currencies = this.$store.getters.getCurrencies(this.currentPage)

      if (!currencies.length) {
        this.loadCurrencies(this.currentPage)
      }
      // axios.get(API_V1_URL + '/prices/currencies/?limit=' + this.itemsPerPage + '&offset=0')
      //   .then((res) => {
      //     this.currenciesAvailable = res.data
      //   })
    },
    computed: {
      currencies() {
        return this.$store.getters.getCurrencies(this.currentPage)
      },
      total() {
        return this.$store.getters.getCurrenciesTotal
      },
    },
    methods: {
      loadCurrencies(page) {
        this.loading = true
        this.$store.dispatch('getCurrencies', {page, itemsPerPage: this.itemsPerPage})
          .finally(() => {
            this.loading = false
          })
      },
      onSelectCurrency(obj) {
      },
      customLabel({ symbol, name }) {
        return `[${symbol.toUpperCase()}] ${name}`
      },
      onSubmit(e) {
        // submit currency and get response
        // if the id already exist
        // if success add new row in table
        this.loading = true
        axios.post(API_V1_URL + `/prices/create`, {currency: this.currency})
          .then(res => {
            // console.log(res)
            if (res.success) {
              this.showModal = false
              this.onMessage('Successfully added ' + this.currency.name)
            } else {
              alert('This currency already exists in the database')
            }
          })
      },
      redirect() {
        this.showModal = false
      },
      onMessage(text) {
        // console.log(text)
        this.successMsg = text
        setTimeout(() => {
          this.successMsg = null
        }, 3000)
      },
    },
    watch: {
      currentPage() {
        this.loadCurrencies(this.currentPage)
      },
    },
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/-service-app/pages/CurrenciesPage.vue